
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter-subscribed",
      function () {
        return require("private-next-pages/newsletter-subscribed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletter-subscribed"])
      });
    }
  